import React, { useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Container, MessageBox, Icon, Title, Text, HrefButton } from './AlreadyAnsweredMessage.styled';
import EditIcon from '@mui/icons-material/Edit';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
function AlreadyAnsweredMessage(props) {
    const { isResponseSent, URL } = props;
    const navigate = useNavigate();

    return (
        <Container>
            <MessageBox>
                <Icon>✅</Icon>
                <Title>{isResponseSent ? "Votre réponse a bien été envoyée !" : "Vous avez déjà répondu à cette enquête"}</Title>
                <Text>
                    Merci d’avoir pris le temps de partager votre avis.
                    <br />
                    Votre participation a bien été enregistrée.
                </Text>

                <HrefButton href={URL}
                >
                    <ArrowCircleRightOutlinedIcon />
                    Revenir à la page d’accueil
                </HrefButton>
            </MessageBox>
        </Container>
    )
}

export default AlreadyAnsweredMessage
